import { Navigate } from 'react-router'

import { withNamespaces } from '@/i18n/route-namespaces'

export const campaignRoutes = {
  path: 'campaign',
  lazy: withNamespaces(['campaign'], async () => {
    const { Campaign } = await import('@/pages/campaign')

    return { Component: Campaign }
  }),
  children: [
    {
      index: true,
      element: <Navigate to="templates" />,
    },
    {
      path: 'templates',
      lazy: withNamespaces(['campaign'], async () => {
        const { CampaignTemplates } = await import('@/pages/campaign/templates')

        return { Component: CampaignTemplates }
      }),
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: 'list',
          lazy: withNamespaces(['campaign'], async () => {
            const { CampaignTemplatesList } = await import(
              '@/pages/campaign/templates/list'
            )

            return { Component: CampaignTemplatesList }
          }),
          handle: {
            title: 'campaign.templates.metadata',
          },
        },
      ],
    },
    {
      path: 'dispatches',
      lazy: withNamespaces(['campaign'], async () => {
        const { CampaignDispatches } = await import(
          '@/pages/campaign/dispatches'
        )

        return { Component: CampaignDispatches }
      }),
      children: [
        {
          index: true,
          element: <Navigate to="list" />,
        },
        {
          path: 'list',
          lazy: withNamespaces(['campaign'], async () => {
            const { CampaignDispatchesList } = await import(
              '@/pages/campaign/dispatches/list'
            )

            return { Component: CampaignDispatchesList }
          }),
          handle: {
            title: 'campaign.dispatches.metadata',
          },
        },
        {
          path: 'create',
          lazy: withNamespaces(['campaign', 'integrations'], async () => {
            const { CampaignDispatchesCreate } = await import(
              '@/pages/campaign/dispatches/create'
            )

            return { Component: CampaignDispatchesCreate }
          }),
          handle: {
            title: 'campaign.dispatches.form.metadata',
            backTo: 'campaign-list',
          },
        },
        {
          path: ':dispatchId/edit',
          lazy: withNamespaces(['campaign', 'integrations'], async () => {
            const { CampaignDispatchesEdit } = await import(
              '@/pages/campaign/dispatches/edit'
            )

            return { Component: CampaignDispatchesEdit }
          }),
          handle: {
            title: 'campaign.dispatches.form.metadata',
            backTo: 'campaign-list',
          },
        },
      ],
    },
  ],
}
